import axios from 'axios';

export default {
  createAttachment(path, attachable, file, config = {}, params = {}) {
    const formData = new FormData();
    formData.append('attachable_id', attachable.id);
    formData.append('attachable_type', attachable.type);
    formData.append('data', file);

    for (const key in params) {
      const value = params[key];
      if (value != null) {
        formData.append(key, params[key]);
      }
    }

    return axios.post(`${path}`, formData, config).then(response => ({
      createdAt: response.data.created_at,
      displayName: response.data.display_name,
      downloadUrl: response.data.download_url,
      fileName: response.data.file_name,
      folderId: response.data.folder_id,
      id: response.data.id,
      ottercon: response.data.ottercon,
      path: response.data.path,
      size: response.data.size,
      uploadedBy: response.data.uploaded_by,
      uploadedOn: response.data.uploaded_on,
      uploadedById: response.data.uploaded_by_id,
      url: response.data.url,
    }));
  },

  updateAttachment(attachment, changes) {
    return axios.put(attachment.path, changes);
  },

  deleteAttachment(path, attachment) {
    return axios.delete(`${path}/${attachment.id}`);
  }
};
